import LocalityForm from './LocalityForm'
export {LocalityForm}
export default LocalityForm
